import { TileSection } from 'foundations-components/transitional/components/Tile';
import { useMediaQuery } from '../../../utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
export const ModalTileSection = props => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(TileSection, Object.assign({
    paddingInline: isMobile ? '300' : undefined
  }, props));
};